import NavMenu from "@/components/NavMenu";
import CopyRightFooter from "@/components/shared/CopyRightFooter";
import { navigationNamespace } from "@/store/modules/navigation";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { CLOSE, OOPS } from "@/views/SharedViewStructures";

interface ErrorState {
  toolbar: boolean;
  errorMessage: string;
}

@Component({
  components: { CopyRightFooter, NavMenu }
})
export default class Error extends Vue {
  @Getter("darkMode", navigationNamespace)
  dark!: boolean;

  @Prop(String)
  errorKey!: string;

  errorStates: Record<string, ErrorState> = {};

  created() {
    this.errorStates[OOPS] = {
      toolbar: true,
      errorMessage: "Oops! Something went wrong."
    };

    this.errorStates[CLOSE] = {
      toolbar: false,
      errorMessage: "Please close and re-open to log back in"
    };
  }

  get errorState() {
    return this.errorStates[this.errorKey];
  }

  back() {
    this.$router.go(-1);
  }
}
